// extracted by mini-css-extract-plugin
export default {"tip":"tip-module___tip___f6b57f99","error":"tip-module___error___cdfd91a4","warning":"tip-module___warning___c5f9f544"};